module.exports = __webpack_public_path__ + "static/media/cover-image2x.2c170fa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/YouTravel/images/cover-image2x.jpg
// module id = 400
// module chunks = 0